export type PersonLabelFields = {
  aggregateId?: string | null;
  firstName?: string | null;
  surname?: string | null;
  preferredName?: string | null;
};

const text = (value: string | null | undefined): string => value?.trim() ?? "";

export const personLabel = (
  person: PersonLabelFields | null | undefined
): string => {
  if (!person) {
    return "";
  }
  const given = text(person.preferredName) || text(person.firstName);
  return [given, text(person.surname)].filter(Boolean).join(" ");
};
